<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn rounded small @click="refresh" color="accent" title="Reîncărcare date tabel">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" label="Căutare" class="mx-4" clearable hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-select
            :items="userTypes"
            item-text="label"
            item-value="_id"
            label="Tip utilizator"
            v-model="selectedUserType"
            hide-details>
          </v-select>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-btn small color="primary" rounded @click="openItemDialog" title="Adăugare utilizator">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item._id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item._id">
          {{ item._id }}
        </span>
      </template>
      <template v-slot:item.approved="{ item }">
        <v-icon :color="item.approved ? 'primary' : 'error'">{{ item.approved ? 'mdi-check' : 'mdi-close' }}</v-icon>
      </template>
      <template v-slot:item.details="{ item }">
        <template v-if="item.details">
          <div v-for="(key, index) in item.details" :key="key + index">
            {{ key }}
          </div>
        </template>
      </template>
      <template v-slot:item.role="{ item }">
        <v-icon v-if="item.role === 'admin'" color="primary">mdi-shield-star</v-icon>
        <v-icon v-if="item.role === 'evaluator'" color="accent">mdi-knife</v-icon>
        <v-icon v-if="item.role === 'aplicant'" color="warning">mdi-snowman</v-icon>
        {{ item.role }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="accent"
            title="editeaza cont">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
            color="error"
            title="sterge cont">
            mdi-delete
          </v-icon>
          <v-icon
            small
            @click="toggleApproved(item)"
            :color="item.approved ? 'error' : 'primary'"
            :title="item.approved ? 'dezactiveaza cont' : 'activeaza cont'">
            {{ item.approved ? 'mdi-close' : 'mdi-check' }}
          </v-icon>
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
      </template>
    </v-data-table>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Adaugare' : 'Modificare' }} Utilizator</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-text-field
              v-model="item.lastName"
              label="Nume"
              hint="Nume"
              required
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              v-model="item.firstName"
              label="Prenume"
              hint="Prenume"
              required
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              v-model="item.email"
              label="Email"
              hint="Email"
              required
              :rules="[rules.required, rules.email]">
            </v-text-field>
            <v-text-field
              v-model="item.password"
              :type="showPass ? 'text' : 'password'"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPass = !showPass"
              label="Parola"
              :hint="itemAction === 'add' ? 'Parola' : 'Completați doar dacă doriți să modificați parola utilizatorului.'"
              required
              :rules="[itemAction === 'add' ? rules.required : val => true, rules.password]">
            </v-text-field>

            <v-switch v-model="item.approved" label="Cont activ / aprobat">
            </v-switch>

            <v-radio-group v-model="item.role" label="Rol" :rules="[rules.required]">
              <v-radio
                v-for="role in ['aplicant', 'evaluator', 'admin']"
                :key="role"
                :label="role"
                :value="role">
              </v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert type="error" v-if="message" dismissible @input="alertChanged">{{ message }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Închide</v-btn>
          <v-btn color="primary" @click="saveItem">Salvează Utilizator</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmati ștergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anulează ștergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Șterge Utilizator</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce'

export default {
  name: 'UsersComponent',

  data: () => ({
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'nrcrt',
        value: 'nrcrt',
        align: 'end',
        sortable: false,
        filterable: false
      },
      {
        text: 'cont activ / aprobat',
        value: 'approved',
        align: 'center',
        sortable: true,
        filterable: true
      },
      {
        text: 'rol',
        value: 'role',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'email',
        value: 'email',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'nume',
        value: 'lastName',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'prenume',
        value: 'firstName',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'detalii',
        value: 'details',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'creat',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'modificat',
        value: 'updatedAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'acțiuni',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    userTypes: [{
      _id: 'aplicant',
      label: 'aplicant'
    }, {
      _id: 'evaluator',
      label: 'evaluator'
    }, {
      _id: 'admin',
      label: 'admin'
    }, {
      _id: 'toate',
      label: 'toate'
    }],
    item: {
      _id: null,
      approved: true,
      role: null,
      firstName: null,
      lastName: null,
      email: null,
      password: null
    },
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,
    rules: {
      required: val => !!val || 'Campul nu poate fi gol!',
      email: value => {
        /* eslint-disable no-useless-escape */
        const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
        return re.test(value) || 'Va rugam sa introduceti o adresa de email valida.'
      },
      password: value => {
        if (!value || !value.length) return true
        /* eslint-disable no-useless-escape */
        const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
        return re.test(value) || 'Campul trebuie sa fie de minim 8 caractere lungime si sa contina: litere mici, litere mari, cifre si caractere speciale (!, @, #, $, %, ^, &)!'
      }
    },
    message: null,
    showPass: false
  }),

  computed: {
    items () {
      return this.$store.getters.usersItems
    },
    options: {
      get () {
        return this.$store.getters.usersOptions
      },
      set (value) {
        this.$store.dispatch('setUsersOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.usersTotal
    },
    loading () {
      return this.$store.getters.usersLoading
    },
    selectedUserType: {
      get () {
        return this.$store.getters.selectedUserType
      },
      set (value) {
        this.$store.dispatch('setSelectedUserType', value)
      }
    },
    search: {
      get () {
        return this.$store.getters.usersSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setUsersSearch', value)
      }, 500)
    },
    user () {
      return this.$store.getters.user
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchUsers')
    },

    toggleApproved (item) {
      if (item._id !== this.user._id) {
        this.$store.dispatch('saveUser', { _id: item._id, approved: !item.approved })
      }
    },

    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
      this.message = null
    },
    openItemDialog () {
      this.itemForm = true
      this.itemAction = 'add'
    },
    async saveItem () {
      const valid = this.$refs.form.validate()
      if (valid) {
        const payload = Object.assign({}, this.item)

        if (!payload._id) { // create user, so load captcha
          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('admincreateuser')
          payload.token = token
        }

        const result = await this.$store.dispatch('saveUser', payload)
        if (result === true) {
          this.closeItemDialog()
        } else {
          if (result.message === 'Where the recaptcha token, bro? ;)') {
            this.message = {
              type: 'error',
              text: 'Validare esuata, va rugam sa reincarcati pagina si sa incercati din nou.'
            }
          } else if (result.message === 'Mr. Robot?') {
            this.message = {
              type: 'error',
              text: 'Validare esuata, va rugam sa reincarcati pagina si sa incercati din nou.'
            }
          } else {
            if (result.name === 'Conflict') {
              this.message = 'Această adresă de email a fost deja folosită.'
            } else {
              this.message = 'Ne pare rău. A apărut o eroare la procesarea cererii...'
            }
          }
        }
      }
    },
    editItem (item) {
      this.item._id = item._id

      this.item.firstName = item.firstName
      this.item.lastName = item.lastName
      this.item.email = item.email
      this.item.role = item.role
      this.item.approved = item.approved

      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteUser', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    alertChanged ($event) {
      if (!$event) this.message = null
    }
  }
}

const defaultItem = {
  _id: null,
  approved: true,
  role: null,
  firstName: null,
  lastName: null,
  email: null,
  password: null
}
</script>
